import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from '@/routes/routes';
import { Helper } from '@archistarai/auth-frontend';

// Setup Vue Router
Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

// Auth Check
router.beforeEach(async (to, from, next) => await Helper.RouterBeforeEach(to, from, next));

export default router;
